// extracted by mini-css-extract-plugin
export var container = "_ga-0";
export var content = "_ga-3";
export var customerTitle = "_ga-4";
export var empty = "_ga-5";
export var gray = "_ga-6";
export var header = "_ga-7";
export var info = "_ga-8";
export var loading = "_ga-2";
export var loadingCard = "_ga-9";
export var oneLine = "_ga-a";
export var personName = "_ga-e";
export var pillContainer = "_ga-b";
export var selected = "_ga-1";
export var text = "_ga-c";
export var twoLines = "_ga-d";
export var unread = "_ga-f";
export var unreadIndicator = "_ga-g";